import React from 'react';
const POINTS = [{
  icon: '✈️',
  title: 'Professional aviation visual references',
  body: 'Access annotated aircraft illustrations, cockpit instrument diagrams, aerodynamic explanations, navigation charts, and flight procedure learning resources.'
}, {
  icon: '🔍',
  title: 'Structured aviation learning process',
  body: 'Move from recognizing aircraft components to interpreting instruments, understanding flight principles, reviewing navigation concepts, and practicing theoretical decision-making.'
}, {
  icon: '🛩️',
  title: '6 specialized private pilot knowledge areas',
  body: 'Aircraft systems, cockpit instruments, aerodynamics, navigation, aviation weather, and essential flight procedures organized into one comprehensive learning system.'
}, {
  icon: '🎁',
  title: '5 practical aviation study bonuses',
  body: 'Knowledge assessments, instrument recognition cards, VFR planning worksheets, oral review scenarios, and a complete 30-day study organization system.'
}, {
  icon: '🔄',
  title: 'Ready to study again and again',
  body: 'Return to the system whenever you need to review a flight concept, recognize an instrument, understand an aerodynamic principle, or organize your private pilot studies.'
}];
export function NotEbook() {
  return <section className="bg-navy py-5 sm:py-7" data-id="element-108" data-mp="203gwpqqjzusd">
      <div className="mx-auto max-w-5xl px-4 sm:px-6" data-id="element-109" data-mp="2xpw8cbwaty80">
        <h2 className="text-center text-2xl leading-none text-white sm:text-4xl" data-id="element-110" data-mp="2xpe7f1yoyvtr">
          THIS ISN'T JUST ANOTHER AVIATION EBOOK
        </h2>
        <p className="mt-1 text-center font-display text-base font-bold uppercase leading-tight text-gold sm:text-2xl" data-id="element-111" data-mp="2nrqd2d4zzqc4">
          IT'S A COMPLETE, READY-TO-USE VISUAL AVIATION STUDY SYSTEM.
        </p>

        <div className="mt-3 grid gap-2 sm:grid-cols-2 sm:gap-2.5" data-id="element-112" data-mp="1ccbfp88vmwgh">
          {POINTS.map((point, i) => <div key={point.title} className={`flex gap-3 rounded-xl border border-white/15 bg-navy-deep p-3 ${i === POINTS.length - 1 ? 'sm:col-span-2' : ''}`} data-id="element-113" data-mp="18agfy86lgr4t" data-mpi={i}>
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-114" data-mp="1eqq0a2q5k18j">
                {point.icon}
              </span>
              <div data-id="element-115" data-mp="zw1wqu4bbcvk">
                <h3 className="text-sm leading-tight text-white sm:text-base" data-id="element-116" data-mp="14t23z8cwelo9">{point.title}</h3>
                <p className="mt-0.5 text-sm leading-snug text-white/80" data-id="element-117" data-mp="r1nkz1izqkh7">{point.body}</p>
              </div>
            </div>)}
        </div>

        <p className="mt-3 text-center font-display text-base font-extrabold uppercase text-white sm:text-xl" data-id="element-118" data-mp="vt5ljoh3qj1n">
          Less scattered studying. Clearer visual explanations.{' '}
          <span className="text-gold" data-id="element-119" data-mp="m1rjb8xrn54t">More structured aviation knowledge.</span>
        </p>
      </div>
    </section>;
}